export function overrideCard(theme) {
  theme.props.MuiCard = {
    variant: 'outlined'
  };
  theme.overrides.MuiCardContent = {
    root: {
      '&:last-child': {
        paddingBottom: undefined
      }
    }
  };
}